// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_m8-0";
export var animationContainer = "_m8-1";
export var itemPrice = "_m8-a";
export var itemizedContent = "_m8-9";
export var itemizedHeader = "_m8-7";
export var itemizedRow = "_m8-8";
export var itemizedSection = "_m8-6";
export var modalContent = "_m8-2";
export var orderName = "_m8-3";
export var refundOption = "_m8-4";
export var refundOptionsContainer = "_m8-5";
export var shippingLabel = "_m8-b";
export var totalRow = "_m8-c";